import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { X } from "lucide-react";
import { fileUpload } from '../../../redux/api/surveyApi/SurveyApi.js';

import ProgressBar from '../../../utils/progressBar/ProgressBar.js';
import { addInventory, updateInventory } from '../../../redux/api/inventoryApi/InventoryApi.js';
import { addinventoryAction, updateinventoryAction } from '../../../redux/reduxSlice/InventorySlice.js';
import './Inventory.css';
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  FormLabel,
  Img
} from '@chakra-ui/react';

function InventoryForm(props) {
  const {
    isUpdateMode,
    dataToEdit,
    formData: initialFormData,
    setIsUpdateMode,
    inventoryROWID,
    onNewDataAdded,
    closeDrawer,
    isDrawerOpen,
    sitesId,
    callback
  } = props;

  const dispatch = useDispatch();
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const [inventoryAttachment, setInventoryAttachment] = useState([]);
  

  const [formData, setFormData] = useState({
    type: false,
    name: "",
    productCode: " ",
    sellingPrice: null,
    purchasePrice: null,
    description: "",
    asStockInHand: null,
    asCommitedStock: null,
    asAvailableForSale: null,
    psAvailableForSale: null,
    psCommitedStock: null,
    psStockInHand: null


  });

  const handleOnClose = () => {
    closeDrawer();
    setIsUpdateMode(false);
    setFormData({
      type: false,
      name: "",
      productCode: " ",
      sellingPrice: null,
      purchasePrice: null,
      description: "",
      asStockInHand: null,
      asCommitedStock: null,
      asAvailableForSale: null,
      psAvailableForSale: null,
      psCommitedStock: null,
      psStockInHand: null
    });
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   console.log(formData);
  //   setShowProgressBar(true);
  //   const payload = {
  //     ...formData,
  //     inventoryAttachment: inventoryAttachment,
  //   };
  //   addInventory(payload)
  //     .then((response) => {
  //       if (response.data.success) {
  //         console.log("response---->", response);
  //         const ROWID = response.data.response.ROWID;
  //         dispatch(addinventoryAction({ ROWID, formData }));
  //         setFormData({
  //           type: false,
  //           name: "",
  //           productCode: " ",
  //           sellingPrice: null,
  //           purchasePrice: null,
  //           description: "",
  //           asStockInHand: null,
  //           asCommitedStock: null,
  //           asAvailableForSale: null,
  //           psAvailableForSale: null,
  //           psCommitedStock: null,
  //           psStockInHand: null
  //         });
  //         setShowProgressBar(false);
  //         toast.success("Inventory added successfully!");
  //         onNewDataAdded()
  //         handleOnClose();
  //       } else {
  //         toast.error("Unable to add Inventory, Please try again!");
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("API Error", error);
  //       setShowProgressBar(false);
  //       toast.error("Failed to add Inventory. Please try again.");
  //     })
  //     .finally(() => {
  //       if (typeof callback === 'function') {
  //         callback();
  //       } else {
  //         console.error('Expected callback to be a function');
  //       }
  //     });
  // };




    const handleSubmit = async (e) => {
      e.preventDefault();
      setShowProgressBar(true);
  
      try {
        // Upload all selected files
        const uploadResults = await Promise.all(
          selectedFiles.map(async (file) => {
            const formData = {
              attachment: file,
              folderName: "attachmentsbucket",
            };
            try {
              const response = await fileUpload(formData);
              if (response.data.success) {
                return response.data.response[0][0]; // Return uploaded file data
              }
            } catch (error) {
              console.error("Upload failed for", file.name, error);
              return null;
            }
          })
        );
  
        // Filter out successful uploads
        const successfulUploads = uploadResults.filter(Boolean);
  
        // Prepare payload with uploaded files
        const payload = {
          ...formData,
          inventoryAttachment: successfulUploads,
        };
  
        // Submit form data
        const response = await addInventory(payload);
        if (response.data.success) {
          const ROWID = response.data.response.ROWID;
          dispatch(addinventoryAction({ ROWID, formData }));
          // Reset form and selected files
          setFormData({
            type: false,
            name: "",
            productCode: " ",
            sellingPrice: null,
            purchasePrice: null,
            description: "",
            asStockInHand: null,
            asCommitedStock: null,
            asAvailableForSale: null,
            psAvailableForSale: null,
            psCommitedStock: null,
            psStockInHand: null
          });
          setSelectedFiles([]);
          toast.success("Non Solar added successfully!");
          onNewDataAdded();
          handleOnClose();
        } else {
          toast.error("Unable to add Non Solar, Please try again!");
        }
      } catch (error) {
        console.error("API Error", error);
        toast.error("Failed to add Non Solar. Please try again.");
      } finally {
        setShowProgressBar(false);
        if (typeof callback === 'function') {
          callback();
        }
      }
    };
  





  useEffect(() => {
    if (isUpdateMode && dataToEdit) {
      setFormData((prev) => ({
        ...prev, ...dataToEdit,
      }));
    }
  }, [isUpdateMode, dataToEdit]);

  useEffect(() => {
    console.log(formData);
  }, [formData]);

  const handelOnUpdate = (e) => {
    e.preventDefault();
    setShowProgressBar(true);
    updateInventory(formData).then((response) => {
      if (response.data.success) {
        setFormData((prev) => ({
          ...prev, ROWID: response?.data.ROWID
        }));
        dispatch(updateinventoryAction(formData));
        toast.success("Non Solar Updated Successfully!!");
      }
      setTimeout(() => {
        handleOnClose();
        setShowProgressBar(false);
        setSubmitDisabled(false);
      }, 300);
    }).catch((error) => {
      toast.error("Non Solar Update Failed!");
      setShowProgressBar(false);
    }).finally(() => {
      setSubmitDisabled(false);
    });
  };

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prevState) => ({
  //     ...prevState,
  //     [name]: value,
  //   }));
  // };
  const handleChange = (e) => {
    const { name, value, type } = e.target;

    // If changing 'type', set it as a boolean instead of a string
    const newValue = name === "type" ? value === "goods" : value;

    setFormData((prevState) => ({
      ...prevState,
      [name]: newValue,
    }));
  };

  const [fileName, setFileName] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);




  const handleFileChange = (event) => {
    if (event.target.files.length > 0) {
      setFileName(event.target.files[0].name);
    }
  };




  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);
    const maxSize = 25 * 1024 * 1024; // 25 MB
    const maxFiles = 5;

    if (files.length === 0) return;

    // Calculate remaining slots
    const remainingSlots = maxFiles - selectedFiles.length;
    if (remainingSlots <= 0) {
      toast.error("You can only upload up to 5 files");
      e.target.value = null; // Reset input
      return;
    }

    // Slice and filter valid files
    const validFiles = files.slice(0, remainingSlots).filter((file) => {
      if (file.size > maxSize) {
        alert(`${file.name} exceeds the 25 MB limit and will not be uploaded.`);
        return false;
      }
      return true;
    });

    // Update selected files state
    setSelectedFiles((prev) => [...prev, ...validFiles]);
    e.target.value = null; // Reset input to allow re-upload
  };

    const removeinventoryAttachment = (index) => {
      setInventoryAttachment((prevAttachments) => prevAttachments.filter((_, i) => i !== index));
    };



  return (
    <>
      <Drawer
        isOpen={isDrawerOpen}
        placement='right'
        size='xl'
        onClose={handleOnClose}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>{isUpdateMode ? "Update Non-Solar Items Form" : "Create Non-Solar Items Form"}</DrawerHeader>
          <DrawerBody>
            {showProgressBar && <ProgressBar colorScheme='pink' />}
            <form onSubmit={isUpdateMode ? handelOnUpdate : handleSubmit}>

              <div className="card" style={{ marginTop: '20px' }}>
                <div className="card-body">
                  <div className='row justify-content-center '>

                       <div className="row justify-content-center">
                                    <div className="col-lg-12 mb-2 mt-2">
                                      <div className="d-flex gap-3 flex-wrap">
                                        {selectedFiles.map((file, index) => (
                                          <div key={index} className="position-relative border p-2 rounded bg-light">
                                            <span className="position-relative">
                                              {file.name}
                                              <span style={{ cursor: "pointer" }} data-bs-toggle="tooltip" data-bs-title="Remove file" className="position-absolute top-0 start-100 translate-middle badge">
                                                <X size={14} color="red" onClick={() => setSelectedFiles(index)} />
                                              </span>
                                            </span>
                                          </div>
                                        ))}
                                      </div>
                                      <label
                                        htmlFor="imageUploadattachement"
                                        className="image-upload card mt-2"
                                        style={{
                                          border: "2px dashed lightgrey",
                                          borderRadius: "10px",
                                          width: "100%",
                                          height: "100px",
                                          display: "flex",
                                          flexDirection: "column",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        <div className="w-25 mx-auto">
                                          <input className="form-control" type="file" id="imageUpload" name="inventoryAttachment" onChange={(e) => handleFileUpload(e, "inventoryAttachment")} multiple />
                                          <div
                                            className="image-upload-content"
                                            style={{
                                              display: "flex",
                                              flexDirection: "column",
                                              justifyContent: "center",
                                              alignItems: "center",
                                            }}
                                          >
                                            <i className="fas fa-cloud-upload-alt" style={{ fontSize: "24px", marginBottom: "5px" }}></i>
                                          </div>
                                        </div>
                                      </label>
                                      <FormLabel className="small-label ps-3">Additional attachments</FormLabel>
                                    </div>
                                  </div>



                  </div>

                  <div className='row mt-4'>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Name' name='name' value={formData?.name} onChange={handleChange} />
                      </div>
                      <FormLabel className="small-label ps-3">Name</FormLabel>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='sku' name='productCode' value={formData?.productCode} onChange={handleChange} />
                      </div>
                      <FormLabel className="small-label ps-3">Product Code</FormLabel>
                    </div>
                  </div>


                </div>
              </div>

              <div className="card" style={{ marginTop: '20px', marginBottom: '20px' }}>
                <div className="card-body">
                  <div className='row '>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <input className='rounded' type='number' style={{ outline: "none", border: "none" }} placeholder='Selling Price' name='sellingPrice' value={formData?.sellingPrice} onChange={handleChange} />
                      </div>
                      <FormLabel className="small-label ps-3">Selling Price </FormLabel>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <input className='rounded' type='number' style={{ outline: "none", border: "none" }} placeholder='Purchase Price' name='purchasePrice' value={formData?.purchasePrice} onChange={handleChange} />
                      </div>
                      <FormLabel className="small-label ps-3">Purchase Price </FormLabel>
                    </div>

                  </div>


                </div>
              </div>

              <div className='row '>
                <div className='col-lg-12 col-md-6 col-sm-12 mb-2'>
                  <textarea className='form-control rounded' rows='4' placeholder='Description' name='description' value={formData?.description} onChange={handleChange} >
                  </textarea>
                  <FormLabel className="small-label ps-3">Description </FormLabel>
                </div>
              </div>

              <div className="card" style={{ marginTop: '20px', marginBottom: '20px' }}>
                <div className="card-body">
                  <h6 className="card-title">Accounting Stock</h6>
                  <div className='row'>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <input className='rounded' type='number' style={{ outline: "none", border: "none" }} placeholder='Stock in Hand' name='asStockInHand' value={formData?.asStockInHand} onChange={handleChange} />
                      </div>
                      <FormLabel className="small-label ps-3">Stock in Hand</FormLabel>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <input className='rounded' type='number' style={{ outline: "none", border: "none" }} placeholder='Commited Stock' name='asCommitedStock' value={formData?.asCommitedStock} onChange={handleChange} />
                      </div>
                      <FormLabel className="small-label ps-3">Commited Stock</FormLabel>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <input className='rounded' type='number' style={{ outline: "none", border: "none" }} placeholder='Available for Sale' name='asAvailableForSale' value={formData?.asAvailableForSale} onChange={handleChange} />
                      </div>
                      <FormLabel className="small-label ps-3">Available for Sale</FormLabel>
                    </div>
                  </div>

                </div>

              </div>

              <div className="card" style={{ marginTop: '20px', marginBottom: '20px' }}>
                <div className="card-body">
                  <h6 className="card-title">Physical Stock</h6>
                  <div className='row'>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <input className='rounded' type='number' style={{ outline: "none", border: "none" }} placeholder='Stock in Hand' name='psStockInHand' value={formData?.psStockInHand} onChange={handleChange} />
                      </div>
                      <FormLabel className="small-label ps-3">Stock in Hand</FormLabel>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <input className='rounded' type='number' style={{ outline: "none", border: "none" }} placeholder='Commited Stock' name='psCommitedStock' value={formData?.psCommitedStock} onChange={handleChange} />
                      </div>
                      <FormLabel className="small-label ps-3">Commited Stock</FormLabel>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <input className='rounded' type='number' style={{ outline: "none", border: "none" }} placeholder='Available for Sale' name='psAvailableForSale' value={formData?.psAvailableForSale} onChange={handleChange} />
                      </div>
                      <FormLabel className="small-label ps-3">Available for Sale</FormLabel>
                    </div>
                  </div>

                </div>

              </div>
            </form>
          </DrawerBody>
          <center>
            <DrawerFooter style={{ display: 'inline-block' }}>
              <div className='gap-3 d-flex'>
                <button variant='outline' className='cancel-button' mr={3} onClick={handleOnClose}>
                  Cancel
                </button>
                <button className='create-button' onClick={(e) => { !isUpdateMode ? handleSubmit(e) : handelOnUpdate(e) }} >
                  {isUpdateMode ? "Update" : "Submit"}
                </button>
              </div>
            </DrawerFooter>
          </center>
        </DrawerContent>
      </Drawer>
    </>
  );
}

export default InventoryForm;


